import * as React from 'react';

import * as _ from 'lodash';
import * as Bluebird from 'bluebird';
import { v4 as UUID } from 'uuid';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab, Toolbar,
    Button, IconButton, Switch as SwitchComp,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider,
    Dialog, DialogTitle, DialogContent, DialogActions,
    FormControlLabel
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';

import { useSnackbar } from 'notistack';

import { LouverSelector, LouverSelectorProps } from '../louverSelector';
import { LayoutEntity, LayoutEntityProps } from '../layoutEntity';
import { LayoutGrid, LayoutGridProps } from '../layoutGrid';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

import {
    LouverSelector as LouverSelectorXM, LouverSelectorRenderProps, useLouverSelectorXM,
    LouverSizing as LouverSizingXM, LouverSizingRenderProps, useLouverSizingXM,
    Entity as EntityXM, useEntityXM,
    Grid as GridXM, useGridXM,
    useStateXM,
    useDiagnosticXM
} from '../xm';

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    },
    grow: {
        flexGrow: 1
    },
    sizesToolbar: {
        alignItems: 'flex-start'
    },
    sizesToolbarHeader: {
        flexGrow: 1
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    },
    entityContainer: {
        padding: theme.spacing(1),
        background: '#F2F3F4'
    },
    textarea: {
        // resize: 'vertical',
        fontSize: 8,
        overflow: 'auto',
        maxWidth: '100%',
        maxHeight: 400
        // whiteSpace: 'nowrap'
    },
    test: {
        padding: theme.spacing(2)
    }
}));

export function LouverXM() {
    const classes = styles();

    const [ debugging, setDebugging ] = React.useState<boolean>(true);

    const {
        sizingEntity, updateSizingEntity,
        sizingGrid,
        sizingState, refreshSizingState,
        selectorEntity, updateSelectorEntity, refreshSelectorEntity,
        selectorGrid,
        onAddPerformanceSizes, onApplyPerformanceSize, onSelectionChange,
        test
    } = useLouverWorkflowXM('Caps', 'Tab.Configuration');

    const refresh = () => {(async () => {
        await refreshSelectorEntity();
    })()}

    const getState = () => {(async () => {
        await refreshSizingState();
        console.log('SIZING STATE', sizingState);
    })()}

    return (
        <React.Fragment>
            <Grid container xs={12} spacing={1} alignItems="flex-start">
                <Grid item xs={12}>
                    <FormControlLabel label="Enable Debugging" control={<SwitchComp checked={debugging} onChange={() => setDebugging(!debugging)} />} />
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={() => test()}>Test</Button>
                    <Button onClick={() => onApplyPerformanceSize()}>Apply Performance Test</Button>
                    <Button onClick={() => refresh()}>Refresh Performance Entity</Button>
                    <Button onClick={() => getState()}>Get State</Button>
                    {/* <Button onClick={() => loadState()}>Load State</Button> */}
                </Grid>
                <Grid item xs={12}>
                    <Paper variant="outlined">
                        <AppBar position="static">
                            <Toolbar variant="dense">
                                <Typography variant="h6">Louver Selector</Typography>
                                <div className={classes.grow}></div>
                                <IconButton edge="start" color="inherit">
                                    <Icons.Add onClick={onAddPerformanceSizes} />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <div className={classes.test}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {selectorEntity ? <LayoutEntity debugging={debugging} entity={selectorEntity} onChange={e => updateSelectorEntity(e.state)} /> : <em>Loading selector entity...</em>}
                                </Grid>

                                <Grid item xs={12}>
                                    {selectorGrid ? <LayoutGrid grid={selectorGrid} onSelectionChanged={onSelectionChange} /> : <em>Loading selector sizes grid...</em>}
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper variant="outlined">
                        <AppBar position="static">
                            <Toolbar variant="dense">
                                <Typography variant="h6">Louver Sizing</Typography>
                            </Toolbar>
                        </AppBar>

                        <div className={classes.test}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {sizingEntity ? <LayoutEntity debugging={debugging} entity={sizingEntity} onChange={e => updateSizingEntity(e.state)} /> : <em>Loading sizing entity...</em>}
                                </Grid>

                                <Grid item xs={12}>
                                    {sizingGrid ? <LayoutGrid grid={sizingGrid} /> : <em>Loading sizing sizes grid...</em>}
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

const useLouverWorkflowXM = (application: string, tab?: string) => {
    // const [ settings ] = Settings.useSettings();
    // const [ serviceClient, setServiceClient ] = React.useState<Services.Grd.SizingServiceClient>();
    // React.useEffect(() => {
    //     setServiceClient(createWellspringServiceClient(Services.Grd.SizingServiceClient, settings.servicesUrl, 'bff.cygnus.grd.sizing'));
    // }, [ settings ]);

    const [ louverSizingContext, addPerformanceSizes, applyPerformanceSize ] = useLouverSizingXM(application);
    const [ sizingEntity, updateSizingEntityBase, refreshSizingEntity ] = useEntityXM(louverSizingContext.entityKey, (tab && louverSizingContext.layouts[tab]?.layout) ?? louverSizingContext.layoutName);
    const [ sizingGrid, refreshSizingGrid ] = useGridXM(louverSizingContext.entityKey, (tab && louverSizingContext.layouts[tab]?.grid) ?? louverSizingContext.sizesGridName);
    const [ sizingState, refreshSizingState ] = useStateXM(louverSizingContext.entityKey);

    const [ louverSelectorContext, selectSizes, updateLouverEntity ] = useLouverSelectorXM(application);
    const [ selectorEntity, updateSelectorEntityBase, refreshSelectorEntity ] = useEntityXM(louverSelectorContext.entityKey, (tab && louverSelectorContext.layouts[tab]?.layout) ?? louverSelectorContext.layoutName);
    const [ selectorGrid, refreshSelectorGrid ] = useGridXM(louverSelectorContext.sizesEntityKey, (tab && louverSelectorContext.layouts[tab]?.grid) ?? louverSelectorContext.sizesGridName);    

    const [ test ] = useDiagnosticXM();

    const [ selectedSizeIds, setSelectedSizeIds ] = React.useState<Array<string>>([])
    const onSelectionChange = (sizeIds: string[]) => {
        setSelectedSizeIds(sizeIds);
    }

    const onAddPerformanceSizes = () => {(async () => {
        await addPerformanceSizes(louverSelectorContext.sizesEntityKey, selectedSizeIds);
        await refreshSizingGrid();
    })()}
    const onApplyPerformanceSize = () => {(async () => {
        if (!selectorGrid || !sizingGrid)
            return;

        await applyPerformanceSize(sizingGrid.rows[0].entityId, louverSelectorContext.sizesEntityKey, selectorGrid.rows[0].entityId);
        await refreshSizingGrid();
    })()}

    const updateSelectorEntity = async (updates: Record<string, string>) => {
        await updateSelectorEntityBase(updates);
        await selectSizes();
        await refreshSelectorGrid();
        
        // await updateLouverEntity(updates);
        // await refreshSelectorEntity();
        // // await updateSelectorEntityBase(updates);
        // // await selectSizes();
        // await refreshSelectorGrid();
    }

    const updateSizingEntity = async (updates: Record<string, string>) => {
        await updateSizingEntityBase(updates);
        await refreshSizingGrid();
    }

    const context = {
        sizingEntity, updateSizingEntity, refreshSizingEntity,
        sizingGrid, refreshSizingGrid,
        sizingState, refreshSizingState,
        selectorEntity, updateSelectorEntity, refreshSelectorEntity,
        selectorGrid, refreshSelectorGrid,
        onSelectionChange,
        onAddPerformanceSizes, onApplyPerformanceSize,
        test
    }

    return context;
}

interface LouverWorkflowXMRenderProps {
    sizing: LouverSizingRenderProps;
    selector: LouverSelectorRenderProps;
    onSelectionChange: (ids: string[]) => void;
    onAddPerformanceSizes: () => void;
}
interface LouverWorkflowXMProps {
    application: string;
    render?: (props: LouverWorkflowXMRenderProps) => JSX.Element;
}
function LouverWorkflowXM({ application, render }: LouverWorkflowXMProps) {
    const [ selectedSizeIds, setSelectedSizeIds ] = React.useState<Array<string>>([])
    const onSelectionChange: LouverWorkflowXMRenderProps['onSelectionChange'] = (sizeIds) => {
        setSelectedSizeIds(sizeIds);
    }

    return (
        <LouverSizingXM
            application={application}
            render={(sizing) => (
                <LouverSelectorXM
                    application={application}
                    render={(selector) => {
                        const onAddPerformanceSizes: LouverWorkflowXMRenderProps['onAddPerformanceSizes'] = () => {
                            sizing.addPerformanceSize(selector.entityKey, selectedSizeIds);
                        }

                        const tmp = (
                            <GridXM
                                entityKey={sizing.entityKey}
                                gridName={sizing.sizesGridName}
                                render={({ grid }) => <LayoutGrid grid={grid} />}
                            />
                        );

                        return (
                            <React.Fragment>
                                {render && render({
                                    sizing,
                                    selector,
                                    onSelectionChange,
                                    onAddPerformanceSizes
                                })}
                            </React.Fragment>
                        );
                    }}
                />
            )}
        />
    )
}